<script>
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import Spinner from './Spinner.svelte';
  import logo from '$lib/assets/logo.png';
  import { t } from '$lib/translations';
  import { loadingScreenCustomLogoUrl } from '$lib/stores';

  let show = false;
  let fadeParams = { delay: 100, duration: 150 };
  let customLogo = $loadingScreenCustomLogoUrl;

  onMount(() => {
    setTimeout(() => {
      show = true;
    }, 100);
  });
</script>

<div class="loading-screen">
  {#if show}
    {#if customLogo}
      <div transition:fade="{fadeParams}" class="column">
        <img alt="Company Logo" src="{customLogo}" class="logo-img" />
        <h2 class="rove-subheader">powered by RoveIQ.</h2>
      </div>
    {:else}
      <div transition:fade="{fadeParams}" class="row">
        <img alt="RoveIQ Logo" src="{logo}" class="logo-img" />
      </div>
    {/if}
    <div transition:fade="{fadeParams}" class="row">
      <Spinner />
    </div>
    <div transition:fade="{fadeParams}" class="row loading-text">
      { $t('content.loading') }
    </div>
  {/if}
</div>

<style lang="postcss">
  .loading-screen {
    @apply flex flex-col justify-center items-center bg-white w-screen h-screen;
  }
  .row {
    @apply w-full flex justify-center items-center my-3;
  }
  .logo-img {
    @apply w-56;
  }
  .rove-subheader{
    @apply w-full flex justify-center;
  }
  .loading-text {
    @apply font-medium text-gray-600 tracking-tight;
  }
</style>
